export * from "./carousel-item";
export * from "./next-icon";
export * from "./prev-icon";

import { CarouselItemComponent } from "./carousel-item";
import { NextIconComponent } from "./next-icon";
import { PrevIconComponent } from "./prev-icon";
export const CarouselAtoms = [CarouselItemComponent, NextIconComponent, PrevIconComponent];
